// extracted by mini-css-extract-plugin
module.exports = {"gradient":"styles_gradient__SbQ5W","videoUploaderGradient":"styles_videoUploaderGradient__cLInZ"};